export default "__VITE_ASSET__zsjajBx9__"